export type Effect<T> = () => (val?: T) => void

export const withEffect = async <T>(promise: Promise<T>, effect?: Effect<T>): Promise<T> => {
  const cleanup = effect?.()
  let result: T | undefined
  try {
    result = await promise
    return result
  } finally {
    cleanup?.(result)
  }
}

export const withEffectFn = <FN extends (...args: any) => Promise<any>>(fn: FN, effect?: Effect<Awaited<ReturnType<FN>>>): FN => {
  return (async (...args: Parameters<FN>) => {
    const cleanup = effect?.()
    let result: Awaited<ReturnType<FN>> | undefined
    try {
      result = await fn(...args)
      return result
    } finally {
      cleanup?.(result)
    }
  }) as FN
}
